import { isObject } from "@app/utils/helper";

const merge = (target, source) => {
	if (isObject(target) && isObject(source)) {
		Object.keys(source).forEach((key) => {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				merge(target[key], source[key]);
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		});
	}

	Object.assign(source || {}, target || {});
	return target;
};

export default merge;
